import { Controller, useFormContext } from 'react-hook-form'
import { Container } from 'src/components/common/Container'
import { Roboto_num2_b16 } from 'src/styles/fonts/RobotoFonts'
import React from 'react'
import { Typography } from 'src/components/common/Typography'
import { Noto_body3_m12 } from 'src/styles/fonts/NotoSansKrFonts'
import { SelfRegUpdatePageProps } from 'src/pages/SelfRegCouponPage/SelfRegCouponUpdatePage'
import styled, { css } from 'styled-components'
import { SelfRegisterCouponFormItemsType } from 'src/types/react-hook-form'
import RenderIf from 'src/components/common/RenderIf'
import { Barcode } from 'src/components/common/Barcode'

const SelfRegUpdateController = ({
  imgStatus,
  imageOnLoadHandler,
  imageOnErrorHandler,
}: Pick<
  SelfRegUpdatePageProps,
  'registerAttribute' | 'imgStatus' | 'imageOnLoadHandler' | 'imageOnErrorHandler'
>) => {
  const { control, getValues } = useFormContext<SelfRegisterCouponFormItemsType>()
  return (
    <Controller
      control={control}
      name="couponImage"
      render={({ field }) => {
        const { value } = field
        const notImageSrc = value === ''
        return (
          <Container $style={S.SelfRegImageBg(notImageSrc)}>
            {/*이미지 등록을 하지 않은 경우 */}
            <RenderIf when={notImageSrc}>
              <S.BarcodeScreenWrap>
                <Barcode.Image barcode_height={80} value={getValues('barcode') as string} />
                <Barcode.Text fontStyle={Roboto_num2_b16} value={getValues('barcode') as string} />
              </S.BarcodeScreenWrap>
            </RenderIf>
            {/*이미지 등록을 한 경우 */}
            <RenderIf when={!notImageSrc}>
              <S.SelfRegImageWrap>
                <React.Fragment>
                  <S.SelfRegImage
                    src={value}
                    onError={imageOnErrorHandler}
                    onLoad={imageOnLoadHandler}
                    $visibility={imgStatus === 'success'}
                    alt="coupon img"
                  />
                  <RenderIf when={imgStatus === 'fail'}>
                    <Typography $fontStyle={Noto_body3_m12} $color="var(--black-50)">
                      이미지 오류
                    </Typography>
                  </RenderIf>
                </React.Fragment>
              </S.SelfRegImageWrap>
            </RenderIf>
          </Container>
        )
      }}
    />
  )
}
export default SelfRegUpdateController
const S = {
  BarcodeScreenWrap: styled.section`
    max-width: 320px;
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    height: 150px;
    padding: 20px;
    border-radius: 20px;
    background-color: var(--white);
  `,
  SelfRegImageBg: (notImageSrc: boolean) => css`
    background-color: var(--black-10);
    height: ${notImageSrc ? '190px' : '100%'};
    display: flex;
    align-items: center;
  `,
  SelfRegImage: styled.img<{ $visibility: boolean }>`
    width: 100%;
    max-width: 360px;
    max-height: 360px;
    height: auto;
    visibility: ${(props) => (props.$visibility ? 'unset' : 'hidden')};
  `,
  SelfRegImageWrap: styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 360px;
    height: 360px;
    gap: 10px;
    margin: 0 auto;
    background-color: var(--black-4);
  `,
}
